import type React from "react";
import {
  generateSampleSentimentData,
  sentimentChartMargins,
  sentimentChartYDomain,
} from "../../../helpers/chartHelpers.js";
import { formatSentimentTickForChart } from "../sentimentScore.js";
import { LineChartComponent } from "./charts.js";

export const PlaceholderSentimentLineChart: React.FC = () => {
  return (
    <div className="relative flex">
      <div className="h-full w-full">
        <div className="pointer-events-none blur-[2px]">
          <LineChartComponent
            data={generateSampleSentimentData()}
            scale="time"
            height={200}
            shouldShowTooltip
            yDomain={sentimentChartYDomain}
            yTickFormatter={formatSentimentTickForChart}
            margin={sentimentChartMargins}
          />
        </div>
      </div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform rounded-md border border-border-light bg-white px-3 py-1.5 text-base font-medium text-foreground">
        Conduct more interviews to see sentiment trends
      </div>
    </div>
  );
};
